import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { CelebrationAnimation } from '@/shared/components/CelebrationAnimation'
import { celebrationAssets } from '@/shared/lib/celebrationAssets'
import { SURVEY_UNAVAILABLE_TITLE } from '../../lib/instrument-info-messages'
import { SURVEY_COMPLETE_HOME } from '../../lib/survey-completion-messages'
import {
  surveyCompletionActionsRowNoRewardSx,
  surveyCompletionCardBodySx,
  surveyCompletionCardSx,
  surveyCompletionCelebrationImgSx,
  surveyCompletionHomeOnlyButtonSx,
  surveyCompletionIllustrationSx,
  surveyCompletionPageWrapSx,
  surveyCompletionRootSx,
  surveyCompletionSubtitleSx,
  surveyCompletionTitleSx,
} from '../../styles/surveyExecutionStyles'

interface SurveyUnavailableViewProps {
  readonly message: string
  readonly onHome: () => void
}

/** Same layout as the already-submitted completion screen, with Return to Home. */
export function SurveyUnavailableView({ message, onHome }: SurveyUnavailableViewProps) {
  return (
    <Box data-testid="survey-unavailable-view" sx={surveyCompletionPageWrapSx}>
      <Box sx={surveyCompletionRootSx}>
        <Box sx={surveyCompletionCardSx}>
          <Box sx={surveyCompletionIllustrationSx} aria-hidden>
            <CelebrationAnimation
              gifSrc={celebrationAssets.surveyCompletedGif}
              staticFallbackSrc={celebrationAssets.surveyCompletedStaticFallback}
              playing
              sx={surveyCompletionCelebrationImgSx}
              data-testid="survey-unavailable-animation"
            />
          </Box>
          <Box sx={surveyCompletionCardBodySx}>
            <Typography component="h1" sx={surveyCompletionTitleSx}>
              {SURVEY_UNAVAILABLE_TITLE}
            </Typography>
            <Typography component="p" sx={surveyCompletionSubtitleSx}>
              {message}
            </Typography>
            <Box sx={surveyCompletionActionsRowNoRewardSx}>
              <Button
                variant="contained"
                onClick={onHome}
                sx={surveyCompletionHomeOnlyButtonSx}
                data-testid="survey-unavailable-home"
              >
                {SURVEY_COMPLETE_HOME}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
